import React from 'react';
import { connect } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  getCoderResponse,
  getPatient,
} from '../../../Redux/CoderApis/main.actions';
import { getCache } from '../../../Redux/Appointment/apt.actions';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import PatientInfo from './PatientInfo';
import './style.css';
import { getCoder } from '../../../Redux/CoderApis/main.actions';
import PatientInfoSkeleton from './PatientInfo/PatientInfoSkeleton';
import PolicyHolderSkeleton from './PolicyHolderInfo/PolicyHolderSkeleton';
import PolicyInfoSkeleton from './PolicyInfo/PolicyInfoSkeleton';
import PolicyInfo from './PolicyInfo/index';
import PolicyHolderInfo from './PolicyHolderInfo';

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: '500 !important',
    paddingBottom: '1.6rem !important',
  },
}));

function PatientInformation(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [policy, setPolicy] = useState([
    {
      active: 1,
      activeCoverageCleared: true,
      clarificationPresent: true,
      clinicId: 0,
      groupNo: '',
      id: 0,
      note: '',
      patientId: 0,
      payerAddressId: 0,
      payerId: 0,
      payerName: '',
      plan: '',
      policyHolderId: '0',
      policyHolderName: '',
      policyHolderRelation: 0,
      policyNo: '',
      policyType: 1,
      ranking: 1,
    },
    {
      active: 1,
      activeCoverageCleared: false,
      clarificationPresent: true,
      clinicId: 0,
      groupNo: '',
      id: 0,
      note: '',
      patientId: 0,
      payerAddressId: 0,
      payerId: 0,
      payerName: '',
      plan: '',
      policyHolderId: '0',
      policyHolderName: '',
      policyHolderRelation: 0,
      policyNo: '',
      policyType: 1,
      ranking: 2,
    },
  ]);
  const policyObjects = [
    {
      active: 1,
      activeCoverageCleared: true,
      clarificationPresent: true,
      clinicId: 0,
      groupNo: '',
      id: 0,
      note: '',
      patientId: 0,
      payerAddressId: 0,
      payerId: 0,
      payerName: '',
      plan: '',
      policyHolderId: '0',
      policyHolderName: '',
      policyHolderRelation: 0,
      policyNo: '',
      policyType: 1,
      ranking: 1,
    },
    {
      active: 1,
      activeCoverageCleared: false,
      clarificationPresent: true,
      clinicId: 0,
      groupNo: '',
      id: 0,
      note: '',
      patientId: 0,
      payerAddressId: 0,
      payerId: 0,
      payerName: '',
      plan: '',
      policyHolderId: '0',
      policyHolderName: '',
      policyHolderRelation: 0,
      policyNo: '',
      policyType: 1,
      ranking: 2,
    },
  ];
  const [patientInfo, setPatientInfo] = useState(null);
  const [policyHolderObject, setPolicyHolderObject] = useState(null);
  const [hasClickedSeeMore, setHasClickedSeeMore] = useState(false);
  const [showAllPolicies, setShowAllPolicies] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const classes = useStyles();
  const currentRow = JSON.parse(sessionStorage.getItem('currentRow'));
  const clinicId = currentRow.clinicId;
  const policyList = props.coderData.patientInfo?.response?.data?.policyDtoList || [];

  useEffect(() => {
    if (props.rowInfo) {
      let data = props.rowInfo;
      setIsLoading(true);
      setShowAllPolicies(false);
      setHasClickedSeeMore(false);
      let payload = {
        applicationId: props.applicationId,
        patientId: data.patientId,
      };
      props.getPatient(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rowInfo]);

  const handleSeeMore = () => {
    setHasClickedSeeMore(true);
    setShowAllPolicies(true);
    setIsFetchingMore(true);
    props.getPatient({
      applicationId: props.applicationId,
      patientId: props.rowInfo.patientId,
      status: 0
    });
  };

  const handleSeeLess = () => {
    setHasClickedSeeMore(false);
    setShowAllPolicies(false);
    setIsFetchingMore(true);
    props.getPatient({
      applicationId: props.applicationId,
      patientId: props.rowInfo.patientId,
    });
  };

  useEffect(() => {
    if (props.coderData.patientInfo && props.coderData.patientInfo.response) {
      let response = props.coderData.patientInfo.response;
      if (response.responseCode === 0) {
        let data = response.data;
        setPatientInfo(data.patientDto);
        // props.patientInfo(data.patient);
        if (showAllPolicies && data?.policyDtoList?.length > 2) {
          setPolicy([...data.policyDtoList]);
        } else {
          if (data?.policyDtoList?.length === 1) {
            let p = [];
            p.push(data.policyDtoList[0]);
            p.push(policyObjects[1]);
            setPolicy(p);
          } else if (data?.policyDtoList?.length >= 2) {
            let p = [...policyObjects];
            if (data.policyDtoList[0]) {
              p[0] = data.policyDtoList[0];
            }
            if (data.policyDtoList[1]) {
              p[1] = data.policyDtoList[1];
            }
            setPolicy([...p]);
          } else {
            setPolicy([...policyObjects]);
          }
        }
        if (data.policyHolderDtoList?.length >= 0) {
          setPolicyHolderObject(data.policyHolderDtoList[0]);
        }
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.coderData.patientInfo, showAllPolicies]);

  useEffect(() => {
    if (isFetchingMore) {
      setIsFetchingMore(false);
    }
  }, [props.coderData.patientInfo]);


  return (
    <div className={'patient_info_main_div'}>
      <Typography className={classes.heading}>Patient Information</Typography>
      {isLoading ? (
        <PatientInfoSkeleton />
      ) : (
        <PatientInfo
          applicationId={props.applicationId}
          rowInfo={props.rowInfo}
          patientInfo={patientInfo}
          clinicId={clinicId}
        />
      )}
      {isLoading ? (
        <PolicyHolderSkeleton />
      ) : (
        <PolicyHolderInfo
          applicationId={props.applicationId}
          rowInfo={props.rowInfo}
          patientInfo={patientInfo ? patientInfo : ''}
          policyHolderObject={policyHolderObject ? policyHolderObject : null}
          clinicId={clinicId}
        />
      )}
      {policy.map((x, i) => (
        <div>
          {isLoading ? (
            <PolicyInfoSkeleton />
          ) : (
            <PolicyInfo
              clinicId={clinicId}
              setRowInfo={props.setRowInfo}
              key={i}
              index={i}
              applicationId={props.applicationId}
              rowInfo={props.rowInfo}
              currentObject={x}
              policyHolderObject={
                policyHolderObject ? policyHolderObject : null
              }
            />
          )}
        </div>
      ))}
      {props.applicationId === 6 && !isLoading && (
        <>
          {isFetchingMore && <PolicyInfoSkeleton />}
          <div style={{ paddingBlock: '10px' }}>
            {hasClickedSeeMore ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant="text" color="primary" onClick={handleSeeLess}>
                  See Less
                </Button>
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant="text" color="primary" onClick={handleSeeMore}>
                  See More
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  coderData: state.coder,
});

const mapDispatchToProps = (dispatch) => ({
  getCoderResponse: (values) => dispatch(getCoderResponse(values)),
  getCoder: (values) => dispatch(getCoder(values)),
  getPatient: (values) => dispatch(getPatient(values)),
  getCache: (values) => dispatch(getCache(values)),
});
PatientInformation.propTypes = {
  getCoderResponse: PropTypes.func,
  getCoder: PropTypes.func,
  getPatient: PropTypes.func,
  getCache: PropTypes.func,
};
// export default connect(mapStateToProps, mapDispatchToProps)(PatientInformation);
export const PatientData = connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientInformation);
